import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";

export type Profile = {
  profile: string;
  prefix: string;
};

export class Profiles {
  static async list(): Promise<Profile[]> {
    const url = new URL(`${BACKEND_BASE_URL}/api/v1/profiles`);
    const response = await request(url, { method: "GET" }, true);
    const json = await response.json();
    return json.profiles || [];
  }
}
